import {Component, OnInit, AfterViewInit, OnDestroy} from '@angular/core';
import {ServicesService} from '../../services.service';
import {AppComponent} from '../../app.component';

declare var $: any;

@Component({
    selector: 'app-plataforma',
    templateUrl: './plataforma.component.html',
    styleUrls: ['./plataforma.component.css'],
    providers: [
        ServicesService
    ]
})
export class PlataformaComponent implements OnInit, AfterViewInit, OnDestroy {

    tabFila: any;
    gArrBaias: any;
    cont: number = 0;
    private dataTableInitialized: boolean = false;
    private isLoading: boolean = false;

    constructor(private _services: ServicesService, private _appcomponent: AppComponent) {}

    /**
     * Lista as baias da unidade atual
     */
private listaBaias() {
    if (this.isLoading) {
        return Promise.resolve();
    }

    this.isLoading = true;
    const functions = this._services;
    
    return functions.listAPIData('listBaias').then(
        reg => {
            let nhtml: string;
            if (reg.sucesso) {
                this.gArrBaias = reg.dados;
                this.listaFila(reg.dados);
                
                $('.linhabaias').html('');
                for (let i = 0; i < reg.dados.length; i++) {
                    const tempo: string = new Date(reg.dados[i].BaiaT).toLocaleTimeString();
                    nhtml =
                        '<div class=\'col-md-3 col-6 p-1 m-0\'>' +
                        '<div class=\'card\'>' +
                        '<div class=\'card-header text-center text-uppercase p-1 text-white ::EmUso::\'><b style="font-weight:bold;">::Descricao::</b></div>' +
                        '<div class=\'card-body p-1\'>' +
                        '<h6 class=\'text-muted text-center text-uppercase m-0 mb-1\'><span style="::PlacaStyle::"> ::Tipo:: ::Placa::</span></h6>' +
                        '<p class=\'text-center m-0 mb-1\'>::Tempo::</p>' +
                        '<p class=\'text-center m-0\' style="font-weight:bold;">::BaiaId::</p>' +
                        '</div>' +
                        '</div>' +
                        '</div>';
                    if (reg.dados[i].EmUso == '1') {
                        nhtml = nhtml.replace(/::EmUso::/g, 'bg-danger');
                        nhtml = nhtml.replace(/::Descricao::/g, reg.dados[i].Descricao);
                        nhtml = nhtml.replace(/::PlacaStyle::/g, 'color: #6c757d; font-weight: bold;');
                        nhtml = nhtml.replace(/::Placa::/g, reg.dados[i].Placa);
                        nhtml = nhtml.replace(/::Tipo::/g, reg.dados[i].Tipo);
                        nhtml = nhtml.replace(/::Tempo::/g, tempo);
                        nhtml = nhtml.replace(/::BaiaId::/g, '<button id=\'lbaia_' + reg.dados[i].FilaId + '\' data-filaid=\'' + reg.dados[i].FilaId + '\' class=\'btn btn-outline-success liberarplataforma\'>Liberar <i class=\'fas fa-check\'></i></button>');
                    } else {
                        nhtml = nhtml.replace(/::EmUso::/g, 'bg-success');
                        nhtml = nhtml.replace(/::Descricao::/g, reg.dados[i].Descricao);
                        nhtml = nhtml.replace(/::PlacaStyle::/g, '');
                        nhtml = nhtml.replace(/::Placa::/g, '&nbsp;');
                        nhtml = nhtml.replace(/::Tipo::/g, '&nbsp;');
                        nhtml = nhtml.replace(/::Tempo::/g, '&nbsp;');
                        nhtml = nhtml.replace(/::BaiaId::/g, '<div class=\'mb-2\'>&nbsp;</div>');
                    }
                    $('.linhabaias').append(nhtml);
                }
            }
            this.isLoading = false;
        }
    ).catch(error => {
        console.error('Erro ao carregar baias:', error);
        this.isLoading = false;
    });
}

    /**
     * Lista a fila da unidade atual
     */
    private listaFila(arrBaias: any) {
        const functions = this._services;
        
        return functions.listAPIData('listFilaPlataforma').then(
            reg => {
                let nhtml: string = '';
                let acao: string = '';
                let plataforma: string = '';
                
                if (reg.sucesso) {
                    const dts = [];
                    for (let i = 0; i < reg.dados.length; i++) {
                        acao = '';
                        
                        if (reg.dados[i].Status == '2') {
                            nhtml = '<select id=\'sel_' + reg.dados[i].Id + '\' class=\'form-control2\'><option value=\'\' selected disabled></option>';
                            for (let j = 0; j < arrBaias.length; j++) {
                                if (arrBaias[j].EmUso == '0') {
                                    nhtml += '<option value=\'' + arrBaias[j].ID + '\'>' + arrBaias[j].Descricao.toUpperCase() + '</option>';
                                }
                            }
                            nhtml += '</select>';
                            acao += '<button id=\'chbaia_' + reg.dados[i].Id + '\' data-filaid=\'' + reg.dados[i].Id + '\' class=\'ml-1 btn btn-outline-dark-min chamabaia\' title=\'Chamar para a Baia\' type=\'button\'><i class=\'fas fa-shipping-fast\'></i></button>';
                        } else {
                            nhtml = '';
                            acao += '<button id=\'chmpl_' + reg.dados[i].Id + '\' data-filaid=\'' + reg.dados[i].Id + '\' class=\'ml-1 btn btn-outline-dark-min chamaplataforma\' type=\'button\' title=\'Chamar para se posicionar em frente a baia\'><i class=\'fas fa-dolly-flatbed\'></i></button>';
                        }
                        
                        plataforma = (reg.dados[i].Plataforma != null) ? new Date(reg.dados[i].Plataforma).toLocaleString() : '';
                        
                        const dt = {
                            order: i + 1, 
                            placa: reg.dados[i].Placa.toUpperCase(), 
                            tipo: reg.dados[i].Tipo.toUpperCase(), 
                            entrada: new Date(reg.dados[i].Entrada).toLocaleString(), 
                            plataforma: plataforma, 
                            tempo: '', 
                            baia: nhtml, 
                            notificacao: '', 
                            acao: acao
                        };
                        dts.push(dt);
                    }
                    
                    this.updateDataTable(dts);
                }
            }
        ).catch(error => {
            console.error('Erro na requisição da fila:', error);
        });
    }

    /**
     * Atualiza a DataTable com novos dados
     */
    private updateDataTable(data: any[]) {
        if (this.dataTableInitialized && this.tabFila) {
            this.tabFila.clear();
            this.tabFila.rows.add(data);
            this.tabFila.draw();
        } else {
            setTimeout(() => {
                if (this.dataTableInitialized && this.tabFila) {
                    this.tabFila.clear();
                    this.tabFila.rows.add(data);
                    this.tabFila.draw();
                }
            }, 500);
        }
    }

    /**
     * Modal simples com Bootstrap
     */
private mostrarMensagem(tipo: string, texto: string) {
    // Remove modais anteriores
    $('#simpleModal').remove();
    $('.modal-backdrop').remove(); // Remove backdrop também
    
    // Define cor e ícone baseado no tipo
    let corHeader = 'bg-primary';
    let icone = 'info-circle';
    
    if (tipo === 'success') {
        corHeader = 'bg-success';
        icone = 'check-circle';
    } else if (tipo === 'error') {
        corHeader = 'bg-danger';
        icone = 'exclamation-triangle';
    } else if (tipo === 'alert') {
        corHeader = 'bg-warning';
        icone = 'exclamation-circle';
    }
    
    // Cria o modal
    const modalHtml = `
        <div class="modal fade" id="simpleModal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header ${corHeader} text-white">
                        <h5 class="modal-title">
                            <i class="fas fa-${icone} mr-2"></i>
                            ${tipo === 'success' ? 'Sucesso' : tipo === 'error' ? 'Erro' : 'Atenção'}
                        </h5>
                        <button type="button" class="close text-white" id="closeModalX">
                            <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="mb-0">${texto}</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary" id="closeModalBtn">OK</button>
                    </div>
                </div>
            </div>
        </div>
    `;
    
    // Adiciona ao body
    $('body').append(modalHtml);
    
    // Mostra o modal
    const $modal = $('#simpleModal');
    $modal.addClass('show').css('display', 'block');
    $('body').addClass('modal-open').append('<div class="modal-backdrop fade show"></div>');
    
    // Função para fechar o modal
    const fecharModal = () => {
        $modal.removeClass('show');
        $modal.css('display', 'none');
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');
        
        // Remove do DOM após animação
        setTimeout(() => {
            $modal.remove();
        }, 300);
    };
    
    // Event listeners para fechar
    $('#closeModalBtn').on('click', fecharModal);
    $('#closeModalX').on('click', fecharModal);
    
    // Fecha ao clicar fora do modal
    $modal.on('click', function(e) {
        if (e.target === this) {
            fecharModal();
        }
    });
    
    // Fecha com ESC
    $(document).on('keydown.modal', function(e) {
        if (e.key === 'Escape') {
            fecharModal();
            $(document).off('keydown.modal');
        }
    });
}

    /**
     * Configura os event handlers
     */
    private setupEventHandlers() {
        const Plataforma = this;

        $('body').off('click', '.chamaplataforma');
        $('body').off('click', '.liberarplataforma');
        $('body').off('click', '.chamabaia');

        $('body').on('click', '.chamaplataforma', function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            const $btn = $(this);
            if ($btn.prop('disabled')) {
                return;
            }
            
            const filaId = $btn.data('filaid');
            Plataforma.chamaPlataforma(filaId);
        });

        $('body').on('click', '.liberarplataforma', function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            const $btn = $(this);
            if ($btn.prop('disabled')) {
                return;
            }
            
            const filaId = $btn.data('filaid');
            Plataforma.liberaBaia(filaId);
        });

        $('body').on('click', '.chamabaia', function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            const $btn = $(this);
            if ($btn.prop('disabled')) {
                return;
            }
            
            const filaId = $btn.data('filaid');
            Plataforma.chamaBaia(filaId);
        });
    }

    chamaPlataforma(filaId: string) {
        const functions = this._services;
        const $btn = $('#chmpl_' + filaId);
        
        $btn.prop('disabled', true);
        functions.waitButton('#chmpl_' + filaId, '<i class=\'fas fa-spinner fa-pulse\'></i>');
        
        const registro = {filaId: filaId};
        
        functions.requestAPIData(registro, 'chamaPlataforma').then(
            reg => {
                if (reg.sucesso) {
                    this.listaBaias()
                    // Mostra mensagem após delay
                    if (reg.sms) {
                        this.mostrarMensagem(
                            'success',
                            'Condutor do veículo informado via SMS.<br>Prazo para se posicionar em frente as baias: até as ' + reg.prazo
                        );
                    } else {
                        this.mostrarMensagem(
                            'alert',
                            'Não foi possível informar o condutor por SMS.<br>Prazo para se posicionar em frente as baias: até as ' + reg.prazo
                        );
                    }
                    
                } else {
                    $btn.prop('disabled', false);
                    functions.returnButton('#chmpl_' + filaId, '<i class=\'fas fa-dolly-flatbed\'></i>');
                    this.mostrarMensagem('error', 'Erro: ' + (reg.mensagem || 'Operação falhou'));
                }
            }
        ).catch(error => {
            console.error('Erro na requisição:', error);
            $btn.prop('disabled', false);
            functions.returnButton('#chmpl_' + filaId, '<i class=\'fas fa-dolly-flatbed\'></i>');
            this.mostrarMensagem('error', 'Erro na comunicação com o servidor');
        });
    }

    liberaBaia(filaId: string) {
        const functions = this._services;
        const $btn = $('#lbaia_' + filaId);
        
        $btn.prop('disabled', true);
        functions.waitButton('#lbaia_' + filaId, 'Aguarde... <i class=\'fas fa-spinner fa-pulse\'></i>');
        
        const registro = {filaId: filaId};
        
        functions.requestAPIData(registro, 'liberarBaia').then(
            reg => {
                if (reg.sucesso) {
                    this.listaBaias();
                    this.mostrarMensagem('success', 'Baia liberada!');
                } else {
                    $btn.prop('disabled', false);
                    functions.returnButton('#lbaia_' + filaId, 'Liberar <i class=\'fas fa-check\'></i>');
                    this.mostrarMensagem('error', 'Erro ao liberar a baia: ' + reg.mensagem);
                }
            }
        ).catch(error => {
            console.error('Erro:', error);
            $btn.prop('disabled', false);
            functions.returnButton('#lbaia_' + filaId, 'Liberar <i class=\'fas fa-check\'></i>');
            this.mostrarMensagem('error', 'Erro na comunicação');
        });
    }

    chamaBaia(filaId: string) {
        const functions = this._services;
        const baiaId = $('#sel_' + filaId).val();
        
        if (baiaId !== null && baiaId !== '' && baiaId !== undefined) {
            const $btn = $('#chbaia_' + filaId);
            $btn.prop('disabled', true);
            functions.waitButton('#chbaia_' + filaId, '<i class=\'fas fa-spinner fa-pulse\'></i>');
            
            const registro = {filaId: filaId, baiaId: baiaId};
            
            functions.requestAPIData(registro, 'chamaBaia').then(
                reg => {
                    if (reg.sucesso) {
                        this.listaBaias();
                        if (reg.sms) {
                            this.mostrarMensagem(
                                'success',
                                'Condutor do veículo informado via SMS.<br>Prazo para se posicionar na baia solicitada: até as ' + reg.prazo
                            );
                        } else {
                            this.mostrarMensagem(
                                'alert',
                                'Não foi possível informar o condutor por SMS.<br>Prazo para se posicionar na baia solicitada: até as ' + reg.prazo
                            );
                        }
                        
                    } else {
                        $btn.prop('disabled', false);
                        functions.returnButton('#chbaia_' + filaId, '<i class=\'fas fa-shipping-fast\'></i>');
                    }
                }
            ).catch(error => {
                console.error('Erro:', error);
                $btn.prop('disabled', false);
                functions.returnButton('#chbaia_' + filaId, '<i class=\'fas fa-shipping-fast\'></i>');
                this.mostrarMensagem('error', 'Erro na comunicação');
            });
        } else {
            this.mostrarMensagem('alert', 'Informe a baia onde o veículo fará a descarga do produto.');
        }
    }

    ngOnInit() {
        this.setupEventHandlers();
        this.listaBaias();
    }

    ngAfterViewInit() {
        const DataTableLanguage = {
            'sEmptyTable': 'Nenhum registro encontrado',
            'sInfo': 'Mostrando _START_ até _END_ de _TOTAL_ registros',
            'sInfoEmpty': 'Mostrando 0 até 0 de 0 registros',
            'sInfoFiltered': '(Filtrados de _MAX_ registros)',
            'sInfoPostFix': '',
            'sInfoThousands': '.',
            'sLengthMenu': '_MENU_ resultados por página',
            'sLoadingRecords': 'Carregando...',
            'sProcessing': 'Processando...',
            'sZeroRecords': 'Nenhum registro encontrado',
            'sSearch': '<i class="fas fa-search" aria-hidden="true"></i>',
            'oPaginate': {
                'sNext': '<i class="fa fa-step-forward" aria-hidden="true"></i>',
                'sPrevious': '<i class="fa fa-step-backward" aria-hidden="true"></i>',
                'sFirst': '<i class="fa fa-backward" aria-hidden="true"></i>',
                'sLast': '<i class="fa fa-forward" aria-hidden="true"></i>'
            },
            'oAria': {
                'sSortAscending': ': Ordenar colunas de forma ascendente',
                'sSortDescending': ': Ordenar colunas de forma descendente'
            }
        };

        setTimeout(() => {
            if ($.fn.DataTable.isDataTable('#tabFila')) {
                $('#tabFila').DataTable().destroy();
            }

            this.tabFila = $('#tabFila').DataTable({
                language: DataTableLanguage,
                lengthChange: false,
                pageLength: 5,
                info: true,
                paging: true,
                searching: true,
                ordering: true,
                responsive: true,
                autoWidth: false,
                columns: [
                    {data: 'order', className: 'text-center w-5'},
                    {data: 'placa', className: 'text-center w-10'},
                    {data: 'tipo', className: 'text-center w-15'},
                    {data: 'entrada', className: 'text-center w-15'},
                    {data: 'plataforma', className: 'text-center w-15'},
                    {data: 'tempo', className: 'text-center w-10'},
                    {data: 'baia', className: 'text-center w-10'},
                    {data: 'acao', className: 'text-center w-15'}
                ]
            });

            $('#tabFila th').removeClass('text-left');
            $('#tabFila_filter input[type=search]').attr('placeholder', 'Pesquisar');
            $('#tabFila_filter input[type=search]').addClass('form-control');

            this.dataTableInitialized = true;
            this.listaBaias();
        }, 200);
    }

    ngOnDestroy() {
        $('body').off('click', '.chamaplataforma');
        $('body').off('click', '.liberarplataforma');
        $('body').off('click', '.chamabaia');
        
        if (this.tabFila) {
            this.tabFila.destroy();
        }
    }
}